import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useGlobalModalContext } from '@creditsights/styleguide-web';
import AskAnalystModalWrapper from './AskAnalystModalWrapper';
import ConfirmSkipOnboardingModal from './ConfirmSkipOnboardingModal';
import ExportBondCompareModal from './ExportBondCompareModal';
import UpgradeSubscriptionModal from './UpgradeSubscriptionModal';

export enum MODAL_TYPES {
  ASK_ANALYST = 'ASK_ANALYST',
  CONFIRM_SKIP_ONBOARDING = 'CONFIRM_SKIP_ONBOARDING',
  UPGRADE_SUBSCRIPTION = 'UPGRADE_SUBSCRIPTION',
  EXPORT_BOND_COMPARE = 'EXPORT_BOND_COMPARE',
}

const MODAL_COMPONENTS = {
  [MODAL_TYPES.ASK_ANALYST]: AskAnalystModalWrapper,
  [MODAL_TYPES.CONFIRM_SKIP_ONBOARDING]: ConfirmSkipOnboardingModal,
  [MODAL_TYPES.UPGRADE_SUBSCRIPTION]: UpgradeSubscriptionModal,
  [MODAL_TYPES.EXPORT_BOND_COMPARE]: ExportBondCompareModal,
};

const GlobalModal = (): React.ReactElement | null => {
  const { store, closeModal } = useGlobalModalContext();
  const { type, props } = store;
  const location = useLocation();

  useEffect(() => {
    if (type) {
      closeModal();
    }
  }, [location]);

  if (!type) {
    return null;
  }

  const ModalComponent = MODAL_COMPONENTS[type];
  return <ModalComponent {...props} />;
};

export default GlobalModal;
